import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class ModelSectionModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (ModelSectionModel._instance == null) ModelSectionModel._instance = new ModelSectionModel(authManager);
        return ModelSectionModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'model-sections/model-sections');

        this.entityName = 'model-sections.ModelSection';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'Model Section';
        this.setLabel = 'Model Sections';

        this.browser = {
            name: 'default-model-sections-modelsection-browser',
            moduleName: 'default-model-sections-modelsection-browser',
            moduleTitle: 'Model Sections',
            moduleStateSlotName: 'default-model-sections-modelsection-browser',
        };

        this.editor = {
            name: 'default-model-sections-modelsection-editor',
            moduleName: 'default-model-sections-modelsection-editor',
            moduleTitle: 'Model Section',
            moduleStateSlotName: 'default-model-sections-modelsection-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                description: '(zajistit jedinečnost v rámci Code/Standard/Project)',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'projectId',
                type: 'Project',
                persistent: true,
                label: 'Project',
            },
            {
                name: 'geoSectionId',
                type: 'GeoSection',
                persistent: true,
                label: 'Geo Section',
                description: 'geoLayer odpovídá vždy jen jedné geoSection, n:1',
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
        ];

    }

}
